function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M512,230.1c0-94.7-114.6-171.5-256-171.5S0,135.4,0,230.1c0,84.4,91,154.6,211,168.8v54.5h87.3v-54.2 c21.4-2.4,41.9-6.5,61.2-12.2l35.3,66.4h98.7l-59.4-100.2C482.1,322,512,278.4,512,230.1L512,230.1z M100.6,242.9 c0-64.8,87.2-117.2,194.6-117.2s186.7,35.9,186.7,117.2c0,44.2-23.4,74.9-62,93.8c-2.1-1.4-4.1-2.6-5.6-3.3 c-9-4.6-24.5-9.3-24.5-9.3s76.3-5.6,76.3-81.7S386.3,165,386.3,165H211v183.6C145.7,329.6,100.6,289.4,100.6,242.9L100.6,242.9z  M299,276.6v-49c50.9,0,77.4-6,77.4,24.1C376.4,283.8,342.7,276.6,299,276.6L299,276.6z M298.2,340.5h23.4 c9.5,0,16.7,10.3,21.1,16.9c-14.2,1.7-29.1,2.5-44.6,2.6L298.2,340.5L298.2,340.5z"
});

function SvgR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.88159a5d.svg";
export { ForwardRef as ReactComponent };